import React from 'react';
import { useGlobalIds } from 'link-redux';
import * as rdfx from '@ontologies/rdf';

import form from '../../../ontology/form';

import FormFieldAddButton from './FormFieldAddButton';
import { formFieldContext } from './FormFieldContext';
import FormInput from './FormInput';

const FormInputs = (): JSX.Element | null => {
  const { values, field } = React.useContext(formFieldContext);
  const [type] = useGlobalIds(field, rdfx.type);
  const hidden = type === form.HiddenInput;

  if (!values) {
    return null;
  }

  return (
    <React.Fragment>
      {values.map((value, index) => (
        <FormInput
          hidden={hidden}
          index={index}
          key={index}
          value={value}
        />
      ))}
      {hidden ? undefined : <FormFieldAddButton />}
    </React.Fragment>
  );
};

export default FormInputs;
